angular.module('dpw.services').factory('organizationService', ['$q', 'api', function ($q, api) {
    var orgLevelData = null;
    var orgInDev = null;
    var fetchOrgPromiseInDev = null;

    function fetchInDev() {
        if (orgInDev != null) {
            return $q.resolve(orgInDev);
        }
        if (fetchOrgPromiseInDev == null) {
            fetchOrgPromiseInDev = api.call(api.myAccount.organizations.get(), function (data) {
                orgInDev = data;
                return data;
            }, angular.noop);
        }
        return fetchOrgPromiseInDev;
    }

    function clearOrgPromise() {
        orgInDev = null;
        fetchOrgPromiseInDev = null;
    }

    return {

        /**
         * Get Organization Info
         * @param [organizationId]
         * @returns {Promise|Promise<T | never>}
         */
        getOrganization: function (organizationId) {
            if (RCDPW.isAdminSite && !organizationId) {
                return $q.reject();
            }

            return $q.resolve()
                .then(function () {
                    if (RCDPW.isAdminSite) {
                        return api.call(api.admin.organizations.get({ id: organizationId }), angular.noop, angular.noop);
                    }

                    return fetchInDev();
                })
                .then(function (res) {
                    return res.organization;
                });
        },
        clearOrgPromise: clearOrgPromise,
        updateStatus: function (options) {
            return $q(function (resolve, reject) {
                api.call(api.admin.organizations.updateStatus(options), function (data) {
                    resolve(data);
                }, function (err, defaultErrorHandler) {
                    reject({
                        err: err,
                        defaultErrorHandler: defaultErrorHandler
                    });
                });
            });
        },

        isNative: function (organization) {
            return _.get(organization, 'type', '') === 'Native';
        },

        isFree: function (organization) {
            return organization && organization.type === 'Free';
        },

        isDeveloper: function (organization) {
            return organization && organization.type === 'Developer';
        },

        isCustomer: function (organization) {
            return organization && organization.type === 'Customer';
        },

        isQuickStartFlowEnabled: function () {
            var _this = this;
            return $q(function (resolve) {
                _this.getOrgData().then(function (orgData) {
                    var quickStartFlowEnabled = _.find(_.get(orgData, 'parameters', []), { id: 'QuickStartFlowEnabled' });
                    resolve(quickStartFlowEnabled && quickStartFlowEnabled.value === 'true');
                });
            });
        },

        isApiCallHistoryEnabled: function () {
            var _this = this;
            return $q(function (resolve) {
                _this.getOrgData().then(function (orgData) {
                    var apiCallHistoryEnabled = _.find(_.get(orgData, 'parameters', []), { id: 'ApiCallHistoryEnabled' });
                    resolve(apiCallHistoryEnabled && apiCallHistoryEnabled.value === 'true');
                });
            });
        },

        getHashedAccountId: function () {
            var _this = this;
            return $q(function (resolve) {
                _this.getOrgData().then(function (orgData) {
                    var hashedAccountId = _.find(_.get(orgData, 'parameters', []), { id: 'HashedAccountId' });
                    resolve(hashedAccountId && hashedAccountId.value);
                });
            });
        },

        getOrgLevelData: function () {
            return $q(function (resolve) {
                api.call(api.myAccount.organizations.getOrgLevelData(), function (data) {
                    if (data) {
                        orgLevelData = data;
                        resolve(data);
                    }
                });
            });
        },

        getOrgData: function () {
            var _this = this;
            return $q(function (resolve) {
                if (orgLevelData) {
                    resolve(orgLevelData);
                } else {
                    _this.getOrgLevelData().then(function (data) {
                        resolve(data);
                    });
                }
            });
        }
    };
}]);
